// Module
var code = `<div class="customer-container" ng-class="customerStyleController.classes"> <style> {{ customerStyleController.customerStyle }}
    {{ customerStyleController.typeStyle }} </style> <div class="customer-header"> <div id="customer-logo"></div> </div> <div class="customer-body" ng-transclude></div> </div> `;
// Exports
module.exports = code;